import IosArrowBack from '@meronex/icons/ios/IosArrowBack';
import React, { useEffect, useState } from 'react';
import LoadingButton from '../../../../Components/Organisms/LoadingButton';
import { useAxios } from '../../../../Hooks';

const FurnishTypes = [
    { type: 'Unfurnished', value: 'UNFURNISHED' },
    { type: 'Semi-Furnished', value: 'SEMI_FURNISHED' },
    { type: 'Furnished', value: 'FURNISHED' }
];

const StepTwo = ({
    setStep,
    selectedProject,
    setSelectedProject,
    furnishType,
    setFurnishType,
    rentOutTime,
    expectedRent,
    setExpectedRent,
    securityDeposit,
    setSecurityDeposit,
    handleSetRentOutTime,
    handleSubmit,
    loading,
    setFurnish,

    Pin,
    PinChangedHandler,
    PinHasError,
    PinBlurHandler,
    PinIsValid,
    city,
    setCity,
    state,
    setState,
    address,
    setAddress,
    listOtherProperty
}) => {
    const [isFormValid, setIsFormValid] = useState(false);
    const [expectedRentError, setExpectedRentError] = useState('');
    const [securityDepositError, setSecurityDepositError] = useState('');
    const [cityError, setCityError] = useState('');
    const [stateError, setStateError] = useState('');
    const { sendExternalRequest: fetchPin } = useAxios();

    const handleExpectedRentChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setExpectedRent(value);
            setExpectedRentError('');
        } else {
            setExpectedRentError('Expected Rent must be a number.');
        }
    };

    const handleSecurityDepositChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setSecurityDeposit(value);
            setSecurityDepositError('');
        } else {
            setSecurityDepositError('Security Deposit must be a number.');
        }
    };

    console.log('furnish Type', furnishType);

    const [isEditable, setIsEditable] = useState({
        unitArea: selectedProject?.unitArea ? false : true,
        configuration: selectedProject?.configuration ? false : true
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSelectedProject((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    useEffect(() => {
        setIsFormValid(false);

        const isBasicInfoValid =
            furnishType &&
            rentOutTime &&
            securityDeposit &&
            expectedRent &&
            selectedProject?.unitArea &&
            selectedProject?.configuration;

        const isOtherPropertyInfoValid =
            !listOtherProperty || (state && city && address && PinIsValid);

        if (isBasicInfoValid && isOtherPropertyInfoValid) {
            setIsFormValid(true);
        } else {
            setIsFormValid(false);
        }
    }, [
        furnishType,
        rentOutTime,
        securityDeposit,
        expectedRent,
        selectedProject?.unitArea,
        selectedProject?.configuration,
        listOtherProperty,
        state,
        city,
        address,
        Pin
    ]);

    useEffect(() => {
        //Fetch address details based on pin code
        if (/^\d{6}$/.test(Pin)) {
            const url = `https://api.postalpincode.in/pincode/${Pin}`;
            const method = 'GET';
            fetchPin(
                {
                    isEncryptedResponse: false,
                    url,
                    method
                },
                (res) => {
                    if (
                        res.status === 200 &&
                        res?.data[0]?.PostOffice?.length > 0
                    ) {
                        const postOffice = res?.data[0]?.PostOffice[0];
                        setCity(postOffice.District);
                        setState(postOffice.State);
                    } else {
                        setCity('');
                        setState('');
                    }
                }
            );
        }
    }, [Pin]);

    return (
        <div className="w-full bg-white h-full flex items-center justify-center px-2 lg:px-0">
            <div className="w-[95%] lg:w-[40%] xl:w-[30%] mx-auto ">
                <div className="flex flex-col  items-center justify-center">
                    <div
                        onClick={() => {
                            setStep((prev) => prev - 1);
                            window?.webengage?.track('BackToRentalsClicked');
                        }}
                        className="flex items-center justify-center text-primary cursor-pointer pb-2"
                    >
                        <IosArrowBack className="inline text-xl" />
                        <p className="inline text-xl">Back to rentals</p>
                    </div>
                    <h2 className="text-2xl font-bold mb-6">
                        Start your earnings
                    </h2>
                </div>
                {!listOtherProperty && (
                    <div
                        className={`flex items-center p-4 border rounded-lg mb-6`}
                    >
                        <img
                            src={selectedProject?.image}
                            alt="Property"
                            className="w-24 h-20 rounded-md mr-4"
                        />
                        <div className="">
                            <h3 className="font-semibold">
                                {selectedProject?.projectName}
                            </h3>
                            <p className=" text-gray-500">
                                {selectedProject?.configuration
                                    ? `${selectedProject?.configuration}${
                                          selectedProject?.configuration
                                              .toLowerCase()
                                              .includes('bhk')
                                              ? ''
                                              : ' BHK'
                                      } |`
                                    : ''}{' '}
                                {selectedProject?.unitArea
                                    ? ` ${selectedProject?.unitArea} ${' '}SqFt`
                                    : ''}
                            </p>
                        </div>
                    </div>
                )}
                {listOtherProperty && (
                    <div className="border rounded-lg p-4">
                        <h3 className="text-lg font-bold mb-4">
                            Property Location
                        </h3>
                        <div className="mb-6">
                            <label className="block font-medium text-gray-700">
                                Address (House No, Building, Street, Area)
                                <span className="text-red-400"> *</span>
                            </label>

                            <textarea
                                type="text"
                                name="address"
                                className="mt-1 block  w-full text-grey-900 h-16 lg:h-12 xl:h-16 rounded-md p-2 border-[#BFBFBF] focus:border-[#BFBFBF] outline-none border-[1px]"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block font-medium text-gray-700 ">
                                Pincode
                                <span className="text-red-400"> *</span>
                            </label>
                            <input
                                className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                type="text"
                                value={Pin}
                                onChange={PinChangedHandler}
                                maxLength={6}
                                onBlur={PinBlurHandler}
                            />
                            {PinHasError && (
                                <p className="text-left text-red-400 text-sm mt-1">
                                    {`Please enter a valid pin`}
                                </p>
                            )}
                        </div>

                        <div className="flex mb-4 mt-2">
                            <div className="w-1/2 pr-2">
                                <label className="block  font-medium text-gray-700">
                                    City / District
                                    <span className="text-red-400"> *</span>
                                </label>
                                <input
                                    type="text"
                                    name="city"
                                    value={city}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^[A-Za-z\s]*$/.test(value)) {
                                            setCity(value);
                                            setCityError(''); 
                                        } else {
                                            setCityError(
                                                'Only letters are allowed'
                                            );
                                        }
                                    }}
                                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                />
                                {cityError && (
                                    <p className="text-red-500 text-sm mt-2">
                                        {cityError}
                                    </p>
                                )}
                            </div>

                            <div className="w-1/2 pl-2">
                                <label className="block font-medium text-gray-700">
                                    State
                                    <span className="text-red-400"> *</span>
                                </label>
                                <input
                                    type="text"
                                    name="state"
                                    value={state}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^[A-Za-z\s]*$/.test(value)) {
                                            setState(value);
                                            setStateError(''); 
                                        } else {
                                            setStateError(
                                                'Only letters are allowed'
                                            );
                                        }
                                    }}
                                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                />
                                {stateError && (
                                    <p className="text-red-500 text-sm mt-2">
                                        {stateError}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                <div className="my-4 space-y-2 ">
                    <label className="block">
                        <span className="text-gray-700 font-medium mb-2 mt-2">
                            Unit Area (SqFt){' '}
                            <span className="text-red-500">*</span>
                        </span>
                        <input
                            type="text"
                            name="unitArea"
                            value={selectedProject?.unitArea}
                            onChange={handleInputChange}
                            disabled={!isEditable.unitArea}
                            className={`mt-1 w-full border rounded-lg p-3 
                                    ${
                                        !isEditable.configuration
                                            ? 'bg-gray-100'
                                            : ''
                                    }`}
                            placeholder="Enter unit area"
                        />
                    </label>
                    <label className="block">
                        <span className=" text-gray-700 font-medium mb-2 mt-2">
                            Configuration{' '}
                            <span className="text-red-500">*</span>
                        </span>
                        <input
                            type="text"
                            name="configuration"
                            value={selectedProject?.configuration}
                            onChange={handleInputChange}
                            disabled={!isEditable.configuration}
                            className={`mt-1 w-full border rounded-lg p-3 ${
                                !isEditable.configuration ? 'bg-gray-100' : ''
                            } `}
                            placeholder="e.g., 4 BHK"
                        />
                    </label>
                </div>

                <div className="mb-4 mt-2">
                    <label className="block text-gray-700 font-medium mb-2">
                        Furnish Type <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-wrap gap-6 lg:gap-4 items-center">
                        {FurnishTypes.map((i) => (
                            <button
                                key={i.type}
                                className={`px-4 py-2 rounded-lg font-semibold text-base ${
                                    furnishType === i.value
                                        ? 'bg-primary text-white'
                                        : 'bg-gray-200 text-gray-700'
                                }`}
                                onClick={() => {
                                    setFurnish(i.type);
                                    setFurnishType(i.value);
                                }}
                            >
                                {i.type}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="mb-4 mt-2">
                    <label className="block text-gray-700 font-medium mb-2">
                        Expected Rent <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        placeholder="Expected Rent (INR)"
                        value={expectedRent}
                        onChange={handleExpectedRentChange}
                        className="w-full p-3 border rounded-lg"
                    />
                    {expectedRentError && (
                        <p className="text-red-500 text-sm mt-2">
                            {expectedRentError}
                        </p>
                    )}
                </div>
                <div className="mb-4 mt-2">
                    <label className="block text-gray-700 font-medium mb-2">
                        Security Deposit <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        placeholder="Security Deposit (INR)"
                        value={securityDeposit}
                        onChange={handleSecurityDepositChange}
                        className="w-full p-3 border rounded-lg"
                    />
                    {securityDepositError && (
                        <p className="text-red-500 text-sm mt-2">
                            {securityDepositError}
                        </p>
                    )}
                </div>

                <div className="mb-6 mt-2">
                    <label className="block text-gray-700 font-medium mb-2">
                        How soon you wish to rent out?{' '}
                        <span className="text-red-500">*</span>
                    </label>
                    <div className="flex flex-wrap gap-6 lg:gap-4 items-center">
                        {[
                            'Immediately',
                            'After 2 months',
                            '1 month',
                            '2 weeks'
                        ].map((time) => (
                            <button
                                key={time}
                                className={`px-4 py-2 rounded-lg font-semibold text-base ${
                                    rentOutTime === time
                                        ? 'bg-primary text-white'
                                        : 'bg-gray-200 text-gray-700'
                                }`}
                                onClick={() => handleSetRentOutTime(time)}
                            >
                                {time}
                            </button>
                        ))}
                    </div>
                </div>

                <LoadingButton
                    disabled={!isFormValid}
                    className={` bg-primary text-white w-full py-3 rounded-lg  cursor-pointer  font-semibold ${
                        !isFormValid ? 'cursor-not-allowed bg-opacity-30' : ''
                    }`}
                    onClick={handleSubmit}
                    loading={loading}
                >
                    Submit
                </LoadingButton>
            </div>
        </div>
    );
};

export default StepTwo;
